<template>
  <div>
    <dougongTemplates />
  </div>
</template>
<script>
import dougongTemplates from './payment/dougongpayment'

export default {
  components: {
    dougongTemplates,
  },
}
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 10px;
  .frm-tips {
    color: #FF0000;
  }
}
</style>
